import { formatTransferNo } from "@/lib/transfer-no"

/** Google-hosted alert tone (Actions sound library). */
export const WORKSPACE_NOTIFICATION_BEEP_URL =
  "https://actions.google.com/sounds/v1/alarms/beep_short.ogg"

export type WorkspaceNotificationRow = {
  id: number
  kind: string
  entityType?: string | null
  entityId?: number | null
  payload?: Record<string, unknown> | null
  readAt?: string | null
  createdAt: string
}

export function playWorkspaceNotificationBeep() {
  if (typeof window === "undefined") return
  try {
    const audio = new Audio(WORKSPACE_NOTIFICATION_BEEP_URL)
    audio.volume = 0.6
    void audio.play()
  } catch {
    /* Autoplay policies may block until user gesture. */
  }
}

export function formatWorkspaceNotification(row: WorkspaceNotificationRow): { title: string; description: string } {
  if (row.kind === "stock_transfer.pending_inbound") {
    const p = row.payload ?? {}
    const partNo = String(p.partNo ?? "Item")
    const qty = String(p.quantity ?? "")
    const from = String(p.sourceBranchName ?? "another branch")
    const docNo = Number(p.transferDocNo ?? 0)
    const ref = docNo > 0 ? formatTransferNo(docNo) : "transfer"
    const isReturn = p.isReturn === true
    return {
      title: isReturn ? "Return transfer pending receipt" : "Incoming stock transfer",
      description: `${ref}: ${qty} × ${partNo} from ${from}`,
    }
  }
  return { title: row.kind, description: "New workspace notification" }
}
